<template>
  <div class="kline_chart">
    <!-- K 线部分 -->
    <div class="main_kline">
      <div class="echart_header">
        <div class="echart_title">
          <div class="left_text_p">
            <span class="name_text">{{ tradingPair }}</span>
            <div class="price_box">
              <div
                :class="{
                  current_up: Number(tradingPairData.ratio) > 0,
                  current_down: Number(tradingPairData.ratio) < 0
                }"
                class="dollar_text"
              >
                {{ tradingPairData.price }}
              </div>
              <div class="cny_text">≈{{ tradingPairData.cny }} CNY</div>
            </div>
            <div class="key_descrition">
              <p>{{ $t('涨幅') }}</p>
              <p
                :class="{
                  current_up: Number(tradingPairData.ratio) > 0,
                  current_down: Number(tradingPairData.ratio) < 0
                }"
                class="value_num"
              >
                {{ Number(tradingPairData.ratio) > 0 ? '+' : ''
                }}{{ tradingPairData.ratio | initFilter('---') }}%
              </p>
            </div>
            <div class="key_descrition">
              <p>24H {{ $t('高') }}</p>
              <p class="value_num">
                {{ tradingPairData.max | initFilter('---') }}
              </p>
            </div>
            <div class="key_descrition">
              <p>24H {{ $t('低') }}</p>
              <p class="value_num">
                {{ tradingPairData.min | initFilter('---') }}
              </p>
            </div>
            <div class="key_descrition">
              <p>24H {{ $t('量') }}</p>
              <p class="value_num">
                {{ tradingPairData.amount | initFilter('---') }}
              </p>
            </div>
          </div>
          <!-- <div class="skin_img" @click="handleSkinIcon()">
            <img
              id="skinImg"
              class="full_img"
              :src="currentSkin === 'black' ? skinNight : skinLight"
              alt
            />
          </div> -->
          <!-- 皮肤切换提示框 -->
          <div v-show="reverseSkinTips" class="skin_tips" ref="skinTips">
            <div
              :class="{
                black_box: index === 1,
                current_skin: currentSkin === item.type
              }"
              class="skin_content"
              @click="handleReverseSkin(item.type), hiddenSkinTipes()"
              v-for="(item, index) in skinType"
              :key="index"
            >
              <div class="img_box">
                <img class="full_img" :src="item.image" alt="" />
              </div>
              <p>{{ item.text }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="config_box">
        <div class="config_box--left">
          <button
            v-for="item in timeList"
            :key="item"
            :class="{ active: item === interval }"
            @click="changeInterval(item)"
          >
            {{ item }}
          </button>
        </div>
        <div class="config_box--right">
          <el-popover placement="bottom-end" trigger="click">
            <span slot="reference" class="indicator-btn">
              {{ $t('指标') }}<i class="el-icon-arrow-down"></i>
            </span>
            <div class="indicator-title" :style="indicatorTitleStyle">
              {{ $t('主要指标') }}
            </div>
            <div>
              <el-button
                v-for="item in ['MA', 'BOLL']"
                :key="item"
                :type="item === indicator[0] ? 'primary' : ''"
                size="small"
                @click="chagneIndicator([item, indicator[1]])"
              >
                {{ item }}
              </el-button>
              <div style="height:10px"></div>
              <div class="indicator-title" :style="indicatorTitleStyle">
                {{ $t('高级指标') }}
              </div>
              <div>
                <el-button
                  v-for="item in ['VOL', 'MACD', 'KDJ', 'RSI', 'WR']"
                  :key="item"
                  :type="item === indicator[1] ? 'primary' : ''"
                  size="small"
                  @click="chagneIndicator([indicator[0], item])"
                >
                  {{ item }}
                </el-button>
              </div>
            </div>
          </el-popover>
        </div>
      </div>
      <div class="echart_box">
        <EchartKLine />
      </div>
    </div>
  </div>
</template>
<script>
import EchartKLine from '@/views/transaction/components/echart/EchartKLine'
import themeColor from '@/common/js/themeColor'

import {
  SET_CURRENT_SKIN,
  SET_INTERVAL,
  SET_INDICATOR
} from '@/store/mutation-types'
import { mapState, mapGetters } from 'vuex'
export default {
  components: {
    EchartKLine
  },
  data() {
    return {
      indicatorTitleStyle: {
        color: 'rgb(20,20,20)',
        marginBottom: '5px'
      },
      timeList: ['1m', '5m', '15m', '30m', '1H', '4H', '1D'],
      skinNight: require('./../../../../assets/images/heiye.png'),
      skinLight: require('./../../../../assets/images/baitian.png'),
      skinType: [
        {
          type: 'white',
          image: require('./../../../../assets/images/white.png'),
          text: this.$t('白色')
        },
        {
          type: 'black',
          image: require('./../../../../assets/images/black.png'),
          text: this.$t('深蓝色')
        }
      ],
      reverseSkinTips: false
    }
  },
  computed: {
    ...mapState({
      currentSkin: (state) => state.transaction.currentSkin,
      tradingPairData: (state) => state.transaction.tradingPairData,
      indicator: (state) => state.transaction.indicator
    }),
    ...mapGetters(['tradingPair', 'interval'])
  },
  methods: {
    chagneIndicator(val) {
      this.$store.commit(`transaction/${SET_INDICATOR}`, val)
    },
    changeInterval(val) {
      this.$store.commit(`transaction/${SET_INTERVAL}`, val)
    },
    handleSkinIcon() {
      this.reverseSkinTips = !this.reverseSkinTips
    },
    hiddenSkinTipes() {
      this.reverseSkinTips = false
    },
    handleReverseSkin(type) {
      this.$store.commit(`transaction/${SET_CURRENT_SKIN}`, type)
      const obj = themeColor[type]
      for (let key in obj) {
        document
          .getElementsByTagName('body')[0]
          .style.setProperty(`--${key}`, obj[key])
      }
    }
  }
}
</script>
<style lang="less" scoped>
.kline_chart {
  .main_kline {
    .echart_header {
      padding: 4px 10px 5px;
      background-color: @titleBgColor1;
      .echart_title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        position: relative;
        .left_text_p {
          display: flex;
          flex-direction: row;
          align-items: center;
          .name_text {
            margin-right: 25px;
            font-size: 16px;
            font-family: PingFangSC-Medium, 'PingFang SC';
            font-weight: 500;
            color: @textColor1;
            line-height: 22px;
          }
          .price_box {
            margin-right: 20px;
            .dollar_text {
              margin-right: 10px;
              height: 25px;
              font-size: 18px;
              font-family: PingFangSC-Medium, 'PingFang SC';
              font-weight: 500;
              color: @textColor4;
              line-height: 25px;
            }
            .cny_text {
              height: 20px;
              font-size: 14px;
              font-family: PingFangSC-Regular, 'PingFang SC';
              font-weight: 400;
              color: @textColor5;
              line-height: 20px;
            }
            // 动态控制字体颜色
            .current_up {
              color: #3baf7c;
            }
            .current_down {
              color: #ff3f4a;
            }
          }
        }
        .key_descrition {
          margin-right: 35px;
          font-size: 14px;
          font-weight: 400;
          color: @textColor5;
          line-height: 20px;
          .value_num {
            font-size: 14px;
            font-family: PingFangSC-Regular, 'PingFang SC';
            font-weight: 400;
            color: @textColor4;
            line-height: 20px;
          }
          // 动态控制字体颜色
          .current_up {
            color: #3baf7c;
          }
          .current_down {
            color: #ff3f4a;
          }
        }
        .skin_img {
          // margin-top: -15px;
          width: 20px;
          height: 20px;
          cursor: pointer;
        }
        .skin_tips {
          position: absolute;
          top: 42px;
          right: 0px;
          padding: 10px;
          width: 180px;
          height: 260px;
          background: rgba(255, 255, 255, 1);
          z-index: 10;
          .skin_content {
            height: 120px;
            overflow: hidden;
            cursor: pointer;
            .img_box {
              margin: 6px auto 0;
              width: 120px;
              height: 80px;
            }
            p {
              margin-top: 5px;
              height: 20px;
              font-size: 14px;
              font-family: PingFangSC-Semibold, 'PingFang SC';
              font-weight: 600;
              color: rgba(51, 51, 51, 1);
              line-height: 20px;
              text-align: center;
            }
          }
          .black_box {
            margin-top: 10px;
          }
          // 动态改变提示框中选中的皮肤背景颜色
          .current_skin {
            background: rgba(229, 235, 245, 1);
          }
        }
      }
      .echart_time {
        margin-top: 5px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .time_button {
          button {
            padding: 0 10px;
            border: none;
            outline: none;
            background: transparent;
            font-size: 14px;
            font-weight: 400;
            color: rgba(125, 132, 161, 1);
            line-height: 20px;
            cursor: pointer;
          }
          button:first-child {
            padding-left: 0;
          }
          .time_active {
            color: rgba(66, 179, 250, 1);
          }
        }
        .type_button {
          margin-top: -7px;
          button {
            padding: 3px 9px;
            border: none;
            outline: none;
            background: transparent;
            border-radius: 4px;
            border: 1px solid rgba(56, 63, 102, 1);
            font-size: 14px;
            font-weight: 400;
            color: rgba(97, 104, 132, 1);
            line-height: 20px;
            cursor: pointer;
          }
          button:first-child {
            margin-right: 10px;
          }
          .type_active {
            color: rgba(66, 179, 250, 1);
            border-color: rgba(66, 179, 250, 1);
          }
        }
      }
      // 动态控制时间图标类型框内容排布
      .echart_time_end {
        justify-content: flex-end;
      }
    }
    .echart_box {
      height: 442px;
      background: @contentBgColor1;
    }
    .config_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      background: @contentBgColor1;
      &--left {
        font-size: 14px;
        font-weight: 400;
        color: #7d84a1;

        button {
          outline: none;
          border: none;
          background: none;
          cursor: pointer;
          color: var(--textColor4, #d2d7ec);
          &:not(:last-child) {
            margin-right: 20px;
          }
          &.active {
            color: #42b3fa;
          }
          &:disabled {
            cursor: not-allowed;
          }
        }
      }
      &--right {
        display: flex;
        .indicator-btn {
          color: @textColor5;
          cursor: pointer;
          // color: red;
        }
      }
    }
  }
}
</style>
